// Expo Router dynamic route for a single customer. The screen body lives in a bracket-free sibling
// (CustomerDetailScreen) so unit tests can import it without resolving a `[id]` path.
import { CustomerDetailScreen } from './CustomerDetailScreen';

export default function CustomerDetailRoute() {
  return <CustomerDetailScreen />;
}
